import { Pipe, PipeTransform } from '@angular/core'
@Pipe({ name: 'ZeroPadding' })
export class ZeroPadding implements PipeTransform {
    transform(value: any, cantidadZeros: number): string {
        let ret: string;
        
        return ret;
    }
}


// WEBPACK FOOTER //
// E:/R1/Angular/turnero/web-visor-cliente/src/app/shared/zero-padding.pipe.ts